import { render, staticRenderFns } from "./required-documents-edit.vue?vue&type=template&id=fe5ebcae"
import script from "./required-documents-edit.vue?vue&type=script&lang=js"
export * from "./required-documents-edit.vue?vue&type=script&lang=js"
import style0 from "./required-documents-edit.vue?vue&type=style&index=0&id=fe5ebcae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports